module.exports = __webpack_public_path__ + "img/januca-2017.1a26c9c7.jpg";